module.exports = __webpack_public_path__ + "img/scroll.85474e21.gif";